import { render, staticRenderFns } from "./AssignSelector.vue?vue&type=template&id=2c766462"
import script from "./AssignSelector.vue?vue&type=script&lang=js"
export * from "./AssignSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports